import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AdminAlertsComponent } from '../admin-alerts/admin-alerts.component';

/**
 * The admin panel's top-level nav.
 *
 * Three sections. People is every account, however you want to look at it:
 * scored, chatting, on a map, or still just a name. Spaces is every event,
 * its lobby and its claim. Abuse is what the guard caught. It was seven
 * entries once, and three of them were the same accounts seen from a
 * different side; the tabs inside each section carry those now.
 *
 * The bell on the right is what came in since this admin last looked.
 */
@Component({
  selector: 'app-admin-nav',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, AdminAlertsComponent],
  template: `
    <nav class="admin-nav">
      <a routerLink="/admin/people" routerLinkActive="on">People</a>
      <a routerLink="/admin/spaces" routerLinkActive="on">Spaces</a>
      <a routerLink="/admin/abuse" routerLinkActive="on">Abuse</a>
      <app-admin-alerts class="alerts"></app-admin-alerts>
    </nav>
  `,
  styles: [
    `
      .admin-nav {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 12px 28px 0;
        font-family: 'Instrument Sans', system-ui, sans-serif;
      }
      a {
        padding: 7px 15px;
        border-radius: 999px;
        font-size: 13px;
        font-weight: 600;
        color: #5e5a57;
        text-decoration: none;
      }
      .alerts {
        margin-left: auto;
      }
      a:hover {
        background: rgba(18, 51, 47, 0.05);
      }
      a.on {
        background: #12332f;
        color: #fff;
      }
    `,
  ],
})
export class AdminNavComponent {}
